import { styled } from 'styled-components';

export const StyledLocalSearch = styled.div`
  margin: 0 ${({ theme }) => theme.sizing.medium} 0;

  div[role='progressbar'] {
    border-color: ${({ theme }) => theme.colours.ink.primary.main};
    border-top-color: transparent !important;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    > div {
      width: 9.3rem;
    }
  }
`;
StyledLocalSearch.displayName = 'StyledLocalSearch';
